export const ratingLevels = {
  okay: {
    text: 'Okay',
    key: 'okay',
    min: 0.0,
    max: 7.0,
  },
  good: {
    text: 'Good',
    key: 'good',
    min: 7.0,
    max: 8.0,
  },
  very_good: {
    text: 'Very Good',
    key: 'very_good',
    min: 8.0,
    max: 8.5,
  },
  excellent: {
    text: 'Excellent',
    key: 'excellent',
    min: 8.5,
    max: 9.0,
  },
  wonderful: {
    text: 'Wonderful',
    key: 'wonderful',
    min: 9.0,
    max: 9.5,
  },
  exceptional: {
    text: 'Exceptional',
    key: 'exceptional',
    min: 9.5,
  },
};

export const generateRatingLevels = (rating: number) => {
  if (rating < ratingLevels.okay.max) {
    return ratingLevels.okay;
  } else if (rating < ratingLevels.good.max) {
    return ratingLevels.good;
  } else if (rating < ratingLevels.very_good.max) {
    return ratingLevels.very_good;
  } else if (rating < ratingLevels.excellent.max) {
    return ratingLevels.excellent;
  } else if (rating < ratingLevels.wonderful.max) {
    return ratingLevels.wonderful;
  } else {
    return ratingLevels.exceptional;
  }
};
